import { useState } from 'react';
import VerifyDetails from '../../Reservation/Booking-Options/VerifyDetails';
import EnhanceStay from '../../Reservation/Booking-Options/EnhanceStay';
import Payment from '../../Reservation/Booking-Options/Payment';
import RoomAssignment from '../../Reservation/Booking-Options/RoomAssignment';

const CheckinDetails = () => {
  const [currentStep, setCurrentStep] = useState(1);

  const steps = [
    { id: 1, title: 'Verify Details', component: VerifyDetails, width: '10%' },
    { id: 2, title: 'Enhance Your Stay', component: EnhanceStay, width: '37%' },
    { id: 3, title: 'Payment', component: Payment, width: '64%' },
    { id: 4, title: 'Check-In', component: RoomAssignment, width: '100%' },
  ];

  const CurrentComponent = steps[currentStep - 1].component;
  const progressWidth = steps[currentStep - 1].width;

  return (
    <div className="min-h-screen bg-white p-4 mt-16 md:p-6">
      <div className="mx-auto bg-white rounded-lg border border-gray-200 overflow-hidden w-full">
        {/* Progress Steps */}
        <div className="p-4 border-b border-gray-200 bg-gray-50">
          <div className="flex justify-between relative">
            {steps.map((step) => (
              <div
                key={step.id}
                className="flex flex-col items-center z-10"
                style={{ width: `${100 / steps.length}%` }}
              >
                <div
                  className={`w-10 h-10 rounded-full flex items-center justify-center border-2 ${currentStep >= step.id ? 'border-black bg-black' : 'border-gray-300 bg-gray-100'}`}
                >
                  <span
                    className={`text-lg font-medium ${currentStep >= step.id ? 'text-white' : 'text-gray-500'}`}
                  >
                    {step.id}
                  </span>
                </div>
                <span
                  className={`text-sm mt-1 text-center font-medium ${currentStep >= step.id ? 'text-black' : 'text-gray-500'}`}
                >
                  {step.title}
                </span>
              </div>
            ))}
            <div className="absolute top-5 left-10 right-10 h-1 bg-gray-200">
              <div
                className="h-1 bg-black transition-all duration-300"
                style={{ width: progressWidth }}
              ></div>
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="p-4 md:p-6">
          <CurrentComponent
            currentStep={currentStep}
            setCurrentStep={setCurrentStep}
            totalSteps={steps.length}
          />
        </div>
      </div>
    </div>
  );
};

export default CheckinDetails;

// import { useState } from 'react';
// import VerifyDetails from '../../Reservation/Booking-Options/VerifyDetails';
// import EnhanceStay from '../../Reservation/Booking-Options/EnhanceStay';
// import Payment from '../../Reservation/Booking-Options/Payment';
// import RoomAssignment from '../../Reservation/Booking-Options/ RoomAssignment';

// const CheckinDetails = () => {
//   const [currentStep, setCurrentStep] = useState(1);

//   const steps = [
//     { id: 1, title: "Verify Details", component: VerifyDetails },
//     { id: 2, title: "Enhance Your Stay", component: EnhanceStay },
//     { id: 3, title: "Payment", component: Payment },
//     { id: 4, title: "Check-In", component: RoomAssignment },
//   ];

//   const CurrentComponent = steps[currentStep - 1].component;

//   return (
//     <div className="min-h-screen bg-white p-4 mt-16 md:p-6">
//       <div className="mx-auto bg-white rounded-lg border border-gray-200 overflow-hidden w-full">
//         {/* Progress Steps */}
//         <div className="p-4 border-b border-gray-200 bg-gray-50">
//           <div className="flex justify-between relative">
//             {steps.map((step) => (
//               <div key={step.id} className="flex flex-col items-center z-10" style={{ width: `${100/steps.length}%` }}>
//                 <div
//                   className={`w-10 h-10 rounded-full flex items-center justify-center border-2 ${currentStep >= step.id ? 'border-black bg-black' : 'border-gray-300 bg-gray-100'}`}
//                 >
//                   <span className={`text-lg font-medium ${currentStep >= step.id ? 'text-white' : 'text-gray-500'}`}>
//                     {step.id}
//                   </span>
//                 </div>
//                 <span className={`text-sm mt-1 text-center font-medium ${currentStep >= step.id ? 'text-black' : 'text-gray-500'}`}>
//                   {step.title}
//                 </span>
//               </div>
//             ))}
//             <div className="absolute top-5 left-10 right-10 h-1 bg-gray-200">
//               <div
//                 className="h-1 bg-black transition-all duration-300"
//                 style={{ width: `${((currentStep - 1) / (steps.length - 1)) * 100}%` }}
//               ></div>
//             </div>
//           </div>
//         </div>

//         {/* Main Content */}
//         <div className="p-4 md:p-6">
//           <CurrentComponent
//             currentStep={currentStep}
//             setCurrentStep={setCurrentStep}
//             totalSteps={steps.length}
//           />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CheckinDetails;
